<!-- 更改昵称 -->
<template>
    <div class="content-box">
      <van-nav-bar
        v-if="memberRelation==null"
        title="更改上级编号"
        fixed
        :placeholder="true"
        :z-index="99"
        left-arrow
        right-text="保存"
        @click-left="goBack"
        @click-right="update"
      />
       <van-nav-bar
        v-else
        title="更改上级编号"
        fixed
        :placeholder="true"
        :z-index="99"
        left-arrow
        @click-left="goBack"
      />
      <!-- header end -->
      <van-cell-group>
        <van-field v-model="parentId" clearable placeholder="请输入上级编号" />
      </van-cell-group>
    </div>
  </template>
  
  <script>
  import { Toast } from "vant";
  
  export default {
    data() {
      return {
        parentId: "",
        memberRelation:null
      };
    },
    components: {},
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      init(){
        var that=this;
        this.$store.dispatch({
            type:"MemberRelationInfo"
        }).then(res=>{
            //console.log(res,"ssssssss");
            that.memberRelation=res.MemberRelation;
            if(that.memberRelation!=null)
            {
                that.parentId=res.MemberRelation.ParentId;
            }
        })
      },
      update() {
        var that = this;
        var regNumber =/^\d+$/;
  
        if (!regNumber.test(this.parentId)) {
          Toast.fail("上级编号必须为数字类型！");
          return false;
        }
  
        this.$store
          .dispatch({
            type: "ChangeParent",
            parentId: this.parentId
          })
          .then(res => {
            Toast(res.Message)
            //console.log(res,'ChangeParent');
            //that.$router.go(-1);
            setTimeout(() => {
                that.init();
            }, 1000);
         
          });
      }
    },
    created() {
      this.init();
  
    }
  };
  </script>
  <style >
  .van-nav-bar__text{
    color: white !important;
  }
  </style>
  <style lang="scss" scoped></style>
  